export default __webpack_public_path__ + "static/media/bookmarkHover.bbed2d93.svg";